export const useOrderedGallery = (product: string) => {
  const configs = useAppConfig()
  const algoliaIndex = configs.currentAlgoliaIndex

  return useFetch(`/api/getProduct/${algoliaIndex}/${product}`, {
    transform: algoliaProduct => getOrderedGallery(algoliaProduct.assets),
  })
}
